import { Dialog, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { i18n } from '../../index'
import css from './incentiveProductDialog.css'
import IncentiveProductForm from './IncentiveProductForm'
import type { SalesIncentiveProduct } from './incentiveProductTypes'
type Props = {
  data: SalesIncentiveProduct | null | undefined
  isOpen: boolean
  stationId?: string
  onClose: (...args: Array<any>) => any
  date?: Date
}

class IncentiveProductDialog extends React.PureComponent<Props> {
  render() {
    const { data, stationId, isOpen, onClose, date } = this.props
    return (
      <Dialog
        /* disableBackdropClick */
        open={isOpen}
        onClose={onClose}
        aria-labelledby='form-dialog-title'
        className={css.component}
      >
        <DialogTitle id='form-dialog-title'>
          {data && data.id
            ? i18n.t('admin.incentiveProducts.title.editDialog')
            : i18n.t('admin.incentiveProducts.title.createDialog')}
        </DialogTitle>
        <DialogContent>
          <IncentiveProductForm date={date} data={data} stationId={stationId} onSubmit={onClose} onCancel={onClose} />
        </DialogContent>
      </Dialog>
    )
  }
}

export default IncentiveProductDialog
